import Home from "./views/Home";
import ProductsList from "./views/ProductList";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import BasketPage from "./components/BasketPage";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
function App() {
  return (
    <Router>
      <div className="App">
        {/* Nav */}
        <Nav />
        <Routes>
          {/*home */}
          <Route path="/" element={<Home />} />
          {/*products list */}
          <Route path="/productslist" element={<ProductsList />} />
          <Route path="/checkout" element={<BasketPage />} />
        </Routes>
        {/*Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
